<template>
  <div>
    <v-icon @click="abrirDialog" size="14" class="cursor-pointer">mdi-pencil</v-icon>

    <SysDialog
      v-model="dialog_ativo"
      titulo="Influenciar a projeção de vendas"
      :largura="!apenas_produto_selecionado ? 800 : 600"
      @click:primary="salvarInfluenciaDeProjecao"
      @click:hidden-dialog="fecharDialog"
    >
      <v-radio-group v-model="apenas_produto_selecionado" v-if="!produto.produto_eh_combinacao">
        <v-radio :value="true">
          <template #label>
            <span class="ml-1">Aplicar apenas no produto selecionado</span>
          </template>
        </v-radio>

        <v-radio :value="false">
          <template #label>
            <span class="ml-1">Aplicar através de filtros</span>
          </template>
        </v-radio>
      </v-radio-group>

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Filtros" class="mb-5" />

      <BlocoFiltrosPrincipais v-show="!apenas_produto_selecionado" :filtros="filtros" ocultar_filtro_filiais />

      <DivisorComLegenda v-if="!apenas_produto_selecionado" legenda="Parâmetros" class="mb-5 mt-2" />

      <div :class="{'mb-3': $v.data_limite.$error}">
        <v-text-field
          v-model="data_limite"
          label="Informe a data limite"
          outlined
          type="date"
          :error-messages="getMensagensValidacao('data_limite')"
          @keypress.enter="salvarInfluenciaDeProjecao()"
        />
      </div>

      <div class="d-flex mt-n3">
        <div class="w-50-porcento mr-2">
          <v-select
            v-model="tipo_ajuste"
            label="Selecione o tipo de ajuste"
            :items="selects.tipos_ajuste"
            item-value="valor"
            item-text="descricao"
            outlined
            :error-messages="getMensagensValidacao('tipo_ajuste')"
            @keypress.enter="salvarInfluenciaDeProjecao()"
          />
        </div>

        <div class="w-50-porcento ml-1">
          <TextFieldFormatadorDeValor
            v-model="qtde_percentual_ajuste"
            label="Informe o percentual"
            outlined
            inteiro
            suffix="%"
            :error-messages="getMensagensValidacao('qtde_percentual_ajuste')"
            @focus="$event.target.select()"
            @keypress.enter="salvarInfluenciaDeProjecao()"
          />
        </div>
      </div>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import {required} from "vuelidate/lib/validators";
import {buscarInfluenciaDeProjecaoAtual, salvarInfluenciaDeProjecao} from "@/api/compraPorProdutosGerais/Produtos";
import {logout} from "@/helpers";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais.vue";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  name: "InfluenciaDeProjecao",
  components: {
    DivisorComLegenda,
    BlocoFiltrosPrincipais,
    TextFieldFormatadorDeValor,
    SysDialog
  },
  props: {
    produto: Object
  },
  data: () => ({
    dialog_ativo: false,
    apenas_produto_selecionado: true,
    filtros: {
      grupos: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      linhas: [],
      compradores: [],
      fornecedores: []
    },
    data_limite: '',
    qtde_percentual_ajuste: 0,
    tipo_ajuste: '',
    selects: {
      tipos_ajuste: [
        { valor: 'A', descricao: 'Aumento'},
        { valor: 'R', descricao: 'Redução'},
      ]
    }
  }),
  validations: {
    data_limite: {
      required,
      data_limite_valida: function () {
        return new Date(this.data_limite) > new Date();
      }
    },
    qtde_percentual_ajuste: {
      required,
    },
    tipo_ajuste: {
      required,
    },
  },
  computed: {
    FATOR_ATUACAO_CALCULADO() {
      if (!['A', 'R'].includes(this.tipo_ajuste) || !(this.qtde_percentual_ajuste > 0)) {
        return 1;
      }

      const percentual = Number(this.qtde_percentual_ajuste) / 100.0;
      return (this.tipo_ajuste === 'A') ? percentual + 1 : 1 - percentual;
    },
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltros'];
    }
  },
  watch: {
    apenas_produto_selecionado() {
      this.setFiltros();
    }
  },
  methods: {
    getMensagensValidacao(campo) {
      if (!this.$v[campo].$dirty) return [];

      if ((this.$v[campo].$params.required !== undefined) && !this.$v[campo].required) {
        return  ["Campo Obrigatório."];
      }

      if ((this.$v[campo].$params.data_limite_valida !== undefined) && !this.$v[campo].data_limite_valida) {
        return  ["Data deve ser maior que hoje."];
      }

      return [];
    },
    buscarInfluenciaDeProjecaoAtual() {
      const parametros = {
        id_grupo: this.produto.id_grupo,
        id_produto: this.produto.id_produto,
        produto_eh_combinacao: this.produto.produto_eh_combinacao ? 'S' : 'N',
      };

      this.$store.dispatch('loading/addRequisicao',
        buscarInfluenciaDeProjecaoAtual(parametros)
          .then(influencia_atual => {
            if (influencia_atual && Number(influencia_atual.fator) !== 1) {
              this.data_limite = influencia_atual.data_limite_formato_americano;
              this.tipo_ajuste = (influencia_atual.fator > 1) ? 'A' : 'R';
              this.qtde_percentual_ajuste = Math.abs((influencia_atual.fator * 100) - 100);
            }
          })
          .catch(logout)
      );
    },
    salvarInfluenciaDeProjecao() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      const parametros = {
        filtros: this.filtros,
        apenas_produto_selecionado: this.apenas_produto_selecionado,
        produto: this.produto.id_produto,
        data_limite: this.data_limite,
        fator: this.FATOR_ATUACAO_CALCULADO,
        produto_eh_combinacao: this.produto.produto_eh_combinacao,
      };

      this.$store.dispatch('loading/addRequisicao',
        salvarInfluenciaDeProjecao(parametros)
          .then(() => {
            this.$emit('update:influencia-projecao', {});
            this.fecharDialog();
          })
          .catch(logout)
      );
    },
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.buscarInfluenciaDeProjecaoAtual();
      this.setFiltros();
    },
    setFiltros() {
      if (this.apenas_produto_selecionado) {
        this.filtros.grupos = [this.produto.id_grupo];
      } else {
        this.filtros.grupos = this.FILTROS_STORE.grupos;
        this.filtros.segmentos = this.FILTROS_STORE.segmentos;
        this.filtros.secoes = this.FILTROS_STORE.secoes;
        this.filtros.compradores = this.FILTROS_STORE.compradores;
        this.filtros.fornecedores = this.FILTROS_STORE.fornecedores;

      }
    },
    fecharDialog() {
      this.$v.$reset();
      this.dialog_ativo = false;
      this.apenas_produto_selecionado = true;
      this.data_limite = '';
      this.tipo_ajuste = '';
      this.qtde_percentual_ajuste = 0;
    }
  }
}
</script>

<style scoped>

</style>
